import * as advancedAlertModalActions from '../AlertModals/AdvancedAlertModal/actions'
import * as basicAlertModalActions from '../AlertModals/BasicAlertModal/actions'
import * as alertsSelectors from '../selectors'
import { default as AlertsLandingPage, ValueProps, EventProps } from './AlertsLandingPage'
import { selectors as authSelectors } from '../../../lifecycle/auth'
import { AppState, Dispatch } from '../../../types'
import { connect } from 'react-redux'

const mapProps = (state: AppState): ValueProps => {
  const isTitanium = authSelectors.isMonitoringCenterPremium(state)
  return {
    isTitanium,
  hasEditRole: authSelectors.hasEditRole(state),
  isBasicAlertsEnabled: alertsSelectors.isBasicAlertsEnabled(state),
  isAPIBasicAlertsEnabled: alertsSelectors.isAPIBasicAlertsEnabled(state) && window.mc.featureFlags.alerts.apiAlerts.enabled === 'true',
  isBasicAlertsLimitExceeded: alertsSelectors.isBasicAlertsLimitExceeded(state),
    organizationDomain: authSelectors.getOrganizationDomain(state)
  }
}

const mapDispatch = (dispatch: Dispatch): EventProps => ({
  handleOpenBasicAlertModal: () => dispatch(basicAlertModalActions.handleOpen()),
  handleOpenAdvancedAlertModal: () => dispatch(advancedAlertModalActions.handleOpen())
})

export default connect(mapProps, mapDispatch)(AlertsLandingPage)
